// NetworkContext.js
import { createContext, useContext, useState } from "react";

const NetworkContext = createContext();

export const NetworkProvider = ({ children }) => {
    const [networkStatus, setNetworkStatus] = useState({
        network: "Secondary",
        primaryNetworkStatus: "Online",
        secondaryNetworkStatus: "Online",
    });

    return (
        <NetworkContext.Provider value={{ networkStatus, setNetworkStatus }}>
            {children}
        </NetworkContext.Provider>
    );
};
export const useNetwork = () => {
    return useContext(NetworkContext);
};